import { categories } from "@/mocks/categories";

const navLinks = [
  { href: "#hot", label: "热门吃瓜" },
  { href: "#categories", label: "视频分类" },
  { href: "#library", label: "视频库" },
  { href: "#columns", label: "深度吃瓜" },
  { href: "#faq", label: "常见问题" },
  { href: "#about", label: "关于我们" },
];

const socials = [
  { icon: "ri-wechat-line", label: "微信" },
  { icon: "ri-weibo-line", label: "微博" },
  { icon: "ri-tiktok-line", label: "抖音" },
  { icon: "ri-bilibili-line", label: "B站" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-200/70 px-4 pt-14 md:px-6 md:pt-16">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-10">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-chat-smile-3-fill text-lg" />
              </span>
              <span className="font-heading text-xl text-primary-600">
                吃瓜<span className="text-accent-600">视频在线</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              汇集各类公开娱乐视频，短视频集锦、完整长视频、综艺名场面、影视花絮与明星动态一应俱全，
              支持按类型与时长筛选，吃瓜追更不迷路。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href="#contact"
                  aria-label={s.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300/60 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h4 className="text-sm font-bold text-foreground-950">内容分类</h4>
            <ul className="mt-4 grid grid-cols-2 gap-3">
              {categories.map((cat) => (
                <li key={cat.key}>
                  <a
                    href="#library"
                    className="flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className={`${cat.icon} text-[13px] text-primary-400`} />
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
            <a
              href="#contact"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-notification-3-line" />
              订阅吃瓜速递
            </a>
          </div>
        </div>

        <div className="flex flex-col gap-3 border-t border-background-300/60 py-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 吃瓜视频在线 · 本站仅聚合公开合法的娱乐内容，坚持真实、有看点的信息分享。
          </p>
          <div className="flex flex-wrap gap-4 text-xs text-foreground-500">
            <a href="#about" className="transition-colors hover:text-primary-600">关于我们</a>
            <a href="#faq" className="transition-colors hover:text-primary-600">常见问题</a>
            <a href="#contact" className="transition-colors hover:text-primary-600">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}